import Colours from '../../../../../Theme/Colours';
import { Theme, ButtonWidth } from '../Buttons.types';

const classes = {};
const useStyles = {
  common: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    height: 72,
    minHeight: 72,
    '&:disabled': {
      color: Colours.Typography.label,
      boxShadow: '0px 2px 6px 1px rgba(0, 22, 99, 0.12)',
    },
  },
  [Theme.primary]: {
    backgroundColor: Colours.PrimaryA.normal,
    color: Colours.Typography.light,
    '&:hover': {
      color: Colours.Typography.light,
      backgroundColor: Colours.PrimaryA.hovered,
    },
    '&:active': {
      color: Colours.Typography.light,
      backgroundColor: Colours.PrimaryA.pressed,
    },
    '&:focus': {
      color: Colours.Typography.light,
      backgroundColor: Colours.PrimaryA.pressed,
    },
  },
  [Theme.secondary]: {
    backgroundColor: Colours.Secondary.Green.normal,
    color: Colours.Typography.light,
    '&:hover': {
      color: Colours.Typography.light,
      backgroundColor: '#25A474',
    },
    '&:active': {
      color: Colours.Typography.light,
      backgroundColor: '#25A474',
    },
    '&:focus': {
      color: Colours.Typography.light,
      backgroundColor: '#25A474',
    },
    '&:disabled': {
      color: Colours.Typography.disabled,
      backgroundColor: Colours.Backgrounds.button,
    },
  },
  [Theme.secondaryAlternative]: {
    backgroundColor: Colours.Secondary.Green.normal,
    color: Colours.Typography.light,
    '&:hover': {
      color: Colours.Typography.light,
      backgroundColor: '#25A474',
    },
    '&:active': {
      color: Colours.Typography.light,
      backgroundColor: '#25A474',
    },
    '&:focus': {
      color: Colours.Typography.light,
      backgroundColor: '#25A474',
    },
    '&:disabled': {
      color: Colours.Typography.disabled,
      backgroundColor: Colours.Backgrounds.button,
    },
  },
  [Theme.danger]: {
    backgroundColor: Colours.Secondary.Red.normal,
    color: Colours.Typography.light,
    '&:hover': {
      color: Colours.Typography.light,
      backgroundColor: '#EA3E3F',
    },
    '&:active': {
      color: Colours.Typography.light,
      backgroundColor: '#EA3E3F',
    },
    '&:focus': {
      color: Colours.Typography.light,
      backgroundColor: '#EA3E3F',
    },
  },
  [Theme.defaultAlternative]: {
    color: Colours.Typography.light,
    backgroundColor: Colours.Typography.active,
    '&:hover': {
      color: Colours.Typography.light,
      backgroundColor: Colours.Typography.active,
    },
    '&:active': {
      color: Colours.Typography.light,
      backgroundColor: Colours.Typography.active,
    },
    '&:focus': {
      color: Colours.Typography.light,
      backgroundColor: Colours.Typography.active,
    },
  },
  [Theme.default]: {
    color: Colours.Typography.label,
    backgroundColor: 'unset',
    '&:hover': {
      color: Colours.Typography.label,
      backgroundColor: Colours.Backgrounds.button,
      borderColor: Colours.Borders.dark,
    },
    '&:active': {
      color: Colours.Typography.label,
      backgroundColor: Colours.Backgrounds.button,
      borderColor: Colours.Borders.dark,
    },
    '&:focus': {
      color: Colours.Typography.label,
      backgroundColor: Colours.Backgrounds.button,
      borderColor: Colours.Borders.dark,
    },
  },
  [Theme.dark]: {
    color: Colours.Typography.light,
    backgroundColor: Colours.Auxiliary.navigation,
    '&:hover': {
      color: Colours.Typography.light,
      backgroundColor: 'rgba(0, 25, 50, 0.85)',
    },
    '&:active': {
      color: Colours.Typography.light,
      backgroundColor: 'rgba(0, 25, 50, 0.85)',
    },
    '&:focus': {
      color: Colours.Typography.light,
      backgroundColor: 'rgba(0, 25, 50, 0.85)',
    },
  },

  [ButtonWidth.full]: {
    borderRadius: '0px 0px 24px 24px',
    boxShadow: '0px 2px 6px 1px rgba(0, 22, 99, 0.12)',
  },
  [ButtonWidth.halfLeft]: {
    borderRadius: 0,
  },
  [ButtonWidth.halfRight]: {
    borderRadius: 0,
  },
  [ButtonWidth.middle]: {
    borderRadius: 0,
  },
};

export default { classes, useStyles };
